/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2155
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.GroupEvent = exports.ContextMenuOptionEvent = exports.BaseEvent = exports.UIEvent = undefined
var r = require(/* 2156 */"./2156")
Object.defineProperty(exports, "UIEvent", {
  enumerable: true,
  get: function () {
    return r.UIEvent
  }
})
var i = require(/* 851 */"./851")
Object.defineProperty(exports, "BaseEvent", {
  enumerable: true,
  get: function () {
    return i.BaseEvent
  }
})
var o = require(/* 2157 */"./2157")
Object.defineProperty(exports, "ContextMenuOptionEvent", {
  enumerable: true,
  get: function () {
    return o.ContextMenuOptionEvent
  }
})
var a = require(/* 2158 */"./2158")
Object.defineProperty(exports, "GroupEvent", {
  enumerable: true,
  get: function () {
    return a.GroupEvent
  }
})
